import { render, staticRenderFns } from "./AttorneysListPage.vue?vue&type=template&id=13d54112&scoped=true"
import script from "./AttorneysListPage.vue?vue&type=script&lang=js"
export * from "./AttorneysListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d54112",
  null
  
)

export default component.exports